/**
 * Registers the harbor chapter's data in the foundation registries. Importing this module is
 * side-effectful and idempotent; the scene imports it. It pulls in `@/characters` (Phaser), so
 * Node tests import the data modules directly instead.
 */
import { MAPS } from '@/maps';
import { ACTOR_DEFS } from '@/characters';
import { registerDialogues } from '@/dialogue';
import { registerTimelines } from '@/cinematics';
import { GREEN_HARBOR_MAP, GH_MAP_ID } from './maps/green-harbor';
import { GREEN_HARBOR_DIALOGUES } from './data/dialogues';
import { GREEN_HARBOR_TIMELINES } from './data/timelines';
import { GREEN_HARBOR_NPCS } from './data/npcs';

let registered = false;
export function registerGreenHarbor(): void {
  if (registered) return;
  registered = true;
  MAPS[GH_MAP_ID] = GREEN_HARBOR_MAP;
  registerDialogues(GREEN_HARBOR_DIALOGUES);
  registerTimelines(GREEN_HARBOR_TIMELINES);
  // Environment NPC looks + dialogue-box names. Never overrides a def another builder owns
  // (the 亚北 merchant keeps the characters builder's def, dev atlas and portrait).
  for (const n of GREEN_HARBOR_NPCS) if (!ACTOR_DEFS[n.id]) ACTOR_DEFS[n.id] = n.look;
}
registerGreenHarbor();
